(function () {
  function initMjShop(root) {
    if (!root || root.dataset.mjsInit === 'true') return;
    var track = root.querySelector('[data-mjs-track]');
    if (!track || !track.children.length) return;

    root.dataset.mjsInit = 'true';
    var cards = track.children;
    var prev = root.querySelector('[data-mjs-prev]');
    var next = root.querySelector('[data-mjs-next]');
    var carousel = root.querySelector('[data-mjs-carousel]');

    function step() {
      return cards[0].getBoundingClientRect().width + 22;
    }

    function refresh() {
      var scrollWidth = track.scrollWidth;
      var clientWidth = track.clientWidth;
      var scrollLeft = track.scrollLeft;
      var ov = scrollWidth - clientWidth > 4;
      if (carousel) carousel.classList.toggle('is-static', !ov);
      if (prev) prev.disabled = scrollLeft <= 2;
      if (next) next.disabled = !ov || scrollLeft >= scrollWidth - clientWidth - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step() * 2, behavior: 'smooth' });
      });
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(refresh);
    }, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();

    try {
      var KEY = 'mj-favoris';
      var favs = JSON.parse(localStorage.getItem(KEY) || '[]');
      root.querySelectorAll('[data-mjs-fav]').forEach(function (btn) {
        var id = btn.getAttribute('data-mjs-fav');
        if (favs.indexOf(id) !== -1) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          var i = favs.indexOf(id);
          if (i === -1) {
            favs.push(id);
            btn.classList.add('is-active');
          } else {
            favs.splice(i, 1);
            btn.classList.remove('is-active');
          }
          localStorage.setItem(KEY, JSON.stringify(favs));
        });
      });
    } catch (e) {}
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mj-shop[data-mjs-root]').forEach(initMjShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('product-recommendations:load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
